import { render } from "./NoOfExpatAndLocalAgainstProgramCampus.vue?vue&type=template&id=114df00d"
import script from "./NoOfExpatAndLocalAgainstProgramCampus.vue?vue&type=script&lang=js"
export * from "./NoOfExpatAndLocalAgainstProgramCampus.vue?vue&type=script&lang=js"
script.render = render

export default script